import React, {FunctionComponent} from "react";
import {
    BottomSectionBackgroundShape
} from "../backgroundShape/bottomSectionBackgroundShape/bottomSectionBackgroundShape.component";
import {DialogButton} from "../dialogButton";
import {OpenSiteModalType} from "../../enums";

const styles = require("./demoRequestBottomCard.component.scss");

export interface DemoRequestBottomCardProps {
    title: string;
    subtitle: string;
    ctaText: string;
    modalType: OpenSiteModalType
}


export const DemoRequestBottomCard: FunctionComponent<DemoRequestBottomCardProps> = props => {
    const {title, subtitle, ctaText, modalType} = props;

    return (
        <div className={styles.container}>
            <div className={styles.requestDemoText}>
                <h2 className={styles.requestDemoTitle}>
                    {title}
                </h2>
                <div className={styles.requestDemoSubTitle}>
                    {subtitle}
                </div>
                <DialogButton text={ctaText} modalType={modalType} buttonProps={{buttonType: 'secondary', isNegative: false}}/>
            </div>
            <BottomSectionBackgroundShape/>
        </div>
    );
};
